<app-site-widget #widget
	[title]="title"
	[elementId]="elementId"
	chartType="column"
	[widgetClass]="widgetClass"
	[siteWidgetOptions]="siteWidgetOptions"
	[widgetOptions]="{noExpand: true}"
	[data]="data"
	[config]="config"
	[tableColumns]="tableColumns"
	[siteId]="siteId"
	[customerId]="customerId"
	[customerName]="customerName"
	[siteName]="siteName"
></app-site-widget>